import * as XLSX from "xlsx";

/**
 * Build AOA rows from schema columns and data rows.
 * @param {Array<{key:string,labelKey:string,get:Function}>} columns
 * @param {Array} rows
 * @param {Function} t - i18n translate fn
 */
export function buildAoA(columns, rows, t) {
  const headers = columns.map((col) => t(col.labelKey));
  const body = (rows || []).map((row) =>
    columns.map((col) => {
      try {
        const value = col.get(row, t);
        return value === undefined || value === null ? "" : value;
      } catch (e) {
        return "";
      }
    })
  );
  return [headers].concat(body);
}

/**
 * Export one or more sheets to an xlsx file.
 * @param {{ sheets: Array<{ name: string, aoa: any[][] }>, filename: string }} options
 */
export function exportAoAToXlsx({ sheets, filename }) {
  const workbook = XLSX.utils.book_new();
  (sheets || []).forEach((sheet) => {
    const worksheet = XLSX.utils.aoa_to_sheet(sheet.aoa || [[]]);
    const name = (sheet.name || "Sheet1").substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, name);
  });
  XLSX.writeFile(workbook, filename);
}

export function exportDateSuffix() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}${m}${day}`;
}

/**
 * Parse amount-log sn into Date (same rules as amountlogs.vue).
 * @param {string} sn
 * @returns {Date|null}
 */
export function parseAmountLogDate(sn) {
  if (!sn || typeof sn !== "string" || sn.length < 14) {
    return null;
  }
  let y;
  let m;
  let d;
  let hh;
  let mm;
  let ss;
  if (sn.substr(0, 1) === "G" || sn.substr(0, 1) === "R") {
    y = sn.substr(1, 4);
    m = sn.substr(5, 2);
    d = sn.substr(7, 2);
    hh = sn.substr(9, 2);
    mm = sn.substr(11, 2);
    ss = sn.substr(13, 2);
  } else {
    y = sn.substr(0, 4);
    m = sn.substr(4, 2);
    d = sn.substr(6, 2);
    hh = sn.substr(8, 2);
    mm = sn.substr(10, 2);
    ss = sn.substr(12, 2);
  }
  const date = new Date(`${y}-${m}-${d}T${hh}:${mm}:${ss}`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatAmountLogDate(sn) {
  const date = parseAmountLogDate(sn);
  if (!date) {
    return sn || "";
  }
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
}
